import type { ConfigurationContextValue } from "./ConfigurationContext";

export const defaultDarkModeLogo = "./logos/logo_atomic_crm_dark.svg";
export const defaultLightModeLogo = "./logos/logo_atomic_crm_light.svg";

export const defaultCurrency = "USD";

export const defaultTitle = "Atomic CRM";

export const defaultDealStages = [
  { value: "identified", label: "Identified" },
  { value: "engaged", label: "Engaged" },
  { value: "evaluating", label: "Evaluating" },
  { value: "proposal", label: "Proposal / Terms" },
  { value: "won", label: "Committed (Won)" },
  { value: "lost", label: "Lost" },
];

export const defaultDealPipelineStatuses = ["won"];

export const defaultDealCategories = [
  { value: "spark-sale", label: "Spark Sale" },
  { value: "jetset-sale", label: "Jetset Sale" },
  { value: "partnership", label: "Partnership" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Cold", color: "#7dbde8" },
  { value: "warm", label: "Warm", color: "#e8cb7d" },
  { value: "hot", label: "Hot", color: "#e88b7d" },
  { value: "in-contract", label: "In Contract", color: "#a4e87d" },
];

export const defaultRecordTypes = [
  { value: "lead", label: "Lead" },
  { value: "customer", label: "Customer" },
  { value: "partner", label: "Partner" },
  { value: "network", label: "Network" },
];

export const defaultTaskTypes = [
  { value: "none", label: "None" },
  { value: "call", label: "Call" },
  { value: "email", label: "Email" },
  { value: "meeting", label: "Meeting" },
  { value: "demo", label: "Demo" },
  { value: "send-proposal", label: "Send proposal" },
  { value: "intro", label: "Intro" },
  { value: "follow-up", label: "Follow-up" },
  { value: "bug", label: "Bug" },
];

export const defaultTaskCategories = [
  { value: "sales", label: "Sales" },
  { value: "follow-up", label: "Follow-up" },
  { value: "dev", label: "Dev" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  recordTypes: defaultRecordTypes,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  taskCategories: defaultTaskCategories,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
